import {
  validation_failed_border_color,
  validation_succcess_border_color,
} from "../consts/colors";
import { error_messages } from "../consts/messages";
import { email_regex, password_regex } from "../consts/regex";

import {
  is_reset_validation_completed,
  password_reset,
  is_password_validated,
  send_reset_link,
  promote_reset_password,
} from "./functions";

var reset_email_validated = false;
var reset_update_confirm_password_validated = false;
var reset_update_password_validated = false;
var password_validation_id = "update_reset_submit";
var email = "";
var password = "";
var password_confirm = "";

jQuery(document).ready(function ($) {
  // ~ ____________________ Send Email Start _______________________________
  //detect email changes to validate the input
  $(document).on("input focus", "#reset-email", function (e) {
    email = e.target.value;

    if (email.endsWith(" ") || email.startsWith(" ")) {
      email = email.replace(" ", "");
    }

    $("#reset-email").css("borderColor", validation_succcess_border_color);
    switch (true) {
      case !email:
        reset_email_validated = false;
        is_reset_validation_completed(reset_email_validated);
        break;
      case !email_regex.test(email):
        reset_email_validated = false;
        is_reset_validation_completed(reset_email_validated);
        break;
      default:
        reset_email_validated = true;
        is_reset_validation_completed(reset_email_validated);
        break;
    }
  });

  $(document).on("submit", "#form__reset__password", function (e) {
    e.preventDefault();
    if (reset_email_validated) {
      send_reset_link(email);
    }
  });
  // ~ ____________________ Send Email finish _______________________________

  // ^ ____________________ Reset new password start _______________________________

  //detect  password changes to validate the input
  $(document).on("input focus", "#reset-update-password", function (e) {
    password = e.target.value;
    $("#reset-update-password").css(
      "borderColor",
      validation_succcess_border_color
    );
    switch (true) {
      case !password:
        reset_update_password_validated = false;
        is_password_validated(
          reset_update_confirm_password_validated,
          reset_update_password_validated,
          password_validation_id
        );
        break;
      case password.length < 6:
        reset_update_password_validated = false;
        is_password_validated(
          reset_update_confirm_password_validated,
          reset_update_password_validated,
          password_validation_id
        );
        break;
      default:
        reset_update_password_validated = true;
        is_password_validated(
          reset_update_confirm_password_validated,
          reset_update_password_validated,
          password_validation_id
        );
    }
  });

  //detect confirm password changes to validate the input
  $(document).on("input focus", "#reset-update-confirm-password", function (e) {
    password_confirm = e.target.value;
    $("#reset-update-confirm-password").css(
      "borderColor",
      validation_succcess_border_color
    );
    switch (true) {
      case !password_confirm:
        reset_update_confirm_password_validated = false;
        break;

      case password_confirm.length < 6:
        reset_update_confirm_password_validated = false;
        is_password_validated(
          reset_update_confirm_password_validated,
          reset_update_password_validated,
          password_validation_id
        );
        break;

      default:
        reset_update_confirm_password_validated = true;
        is_password_validated(
          reset_update_confirm_password_validated,
          reset_update_password_validated,
          password_validation_id
        );
    }
  });

  $(document).on("submit", "#form__reset__update__password", function (e) {
    e.preventDefault();
    if (password == password_confirm) {
      if (
        reset_update_confirm_password_validated &&
        reset_update_password_validated
      ) {
        let reset_url = new URL(window.location.href);
        let code = reset_url.searchParams.get("oobCode");
        password_reset(code, password);
      }
    } else {
      $("#reset-update-password").css(
        "borderColor",
        validation_failed_border_color
      );
      $("#reset-update-confirm-password").css(
        "borderColor",
        validation_failed_border_color
      );
      $("#reset-update-password-error").text(
        error_messages.confirm_password_match
      );
    }
  });

  // ^ ____________________ Reset new password finish _______________________________

  var reset__url = new URL(window.location.href);
  if (reset__url.searchParams.get("mode") == "resetPassword") {
    promote_reset_password();
  }
});
